import STableContainer from './tableContainer.styled';
import {Table} from '@material-ui/core';
import React, {ReactNode, useRef} from 'react';
import TCompactHead from '@/Website/Components/UI/Table/TSmartHead';
import {TBody} from '@/Website/Components/UI';
import {useScrollToTopOnUpdate} from '@/Hooks';

interface TableContainerProps {
  headers: Array<string>;
  children: ReactNode;
  isLoading?: boolean;
  isSmall?: boolean;
  stickyHeader?: boolean;
}
const TableContainer: React.FC<TableContainerProps> = props => {
  const {children, isLoading, headers, isSmall, stickyHeader} = props;
  const tableRef = useRef(null);
  useScrollToTopOnUpdate(tableRef, isLoading);
  return (
    <>
      <STableContainer className="TableContainer" ref={tableRef}>
        <Table aria-label="data table" stickyHeader={stickyHeader}>
          <TCompactHead headers={headers} isSmall={isSmall} />
          <TBody loader={{isShow: isLoading, colNumber: headers.length}}>{children}</TBody>
        </Table>
      </STableContainer>
    </>
  );
};
export default TableContainer;
